module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/fin/account_report/account_report-list/account_report-list.component.scss
// module id = ./src/app/views/fin/account_report/account_report-list/account_report-list.component.scss
// module chunks = main